import { twMerge } from 'tailwind-merge';
import Text, { TextProps } from './Text';
import { Tooltip } from './Tooltip';
import ConditionalWrapper from '../ConditionalWrapper';

type TextWithCopyProps = TextProps & {
  hideTooltip?: boolean;
};

export default function TextWithTooltip(props: TextWithCopyProps) {
  const { hideTooltip, ...textProps } = props;
  return (
    <ConditionalWrapper
      condition={!hideTooltip}
      wrapper={
        <Tooltip
          text={textProps.text}
          placement="bottom"
          classNameContainer="relative truncate"
        />
      }
    >
      <Text
        {...textProps}
        className={twMerge('truncate', textProps.className)}
      />
    </ConditionalWrapper>
  );
}
